"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _TextInput = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/TextInput"));

var _File = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/File"));

var _Select = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Select"));

var _Checkbox = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Checkbox"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ImageForm = function ImageForm(_ref) {
  var _onChange = _ref.onChange,
      _ref$state = _ref.state,
      _ref$state$url = _ref$state.url,
      url = _ref$state$url === void 0 ? '' : _ref$state$url,
      _ref$state$mobileUrl = _ref$state.mobileUrl,
      mobileUrl = _ref$state$mobileUrl === void 0 ? '' : _ref$state$mobileUrl,
      largeImageUrl = _ref$state.largeImageUrl,
      _ref$state$imageZoom = _ref$state.imageZoom,
      imageZoom = _ref$state$imageZoom === void 0 ? 'none' : _ref$state$imageZoom,
      _ref$state$alt = _ref$state.alt,
      alt = _ref$state$alt === void 0 ? '' : _ref$state$alt,
      _ref$state$title = _ref$state.title,
      title = _ref$state$title === void 0 ? '' : _ref$state$title,
      _ref$state$alignment = _ref$state.alignment,
      alignment = _ref$state$alignment === void 0 ? 'fill' : _ref$state$alignment,
      _ref$state$link = _ref$state.link,
      link = _ref$state$link === void 0 ? '' : _ref$state$link,
      _ref$state$openInNewT = _ref$state.openInNewTab,
      openInNewTab = _ref$state$openInNewT === void 0 ? false : _ref$state$openInNewT,
      _ref$state$loadingMet = _ref$state.loadingMethod,
      loadingMethod = _ref$state$loadingMet === void 0 ? 'normal' : _ref$state$loadingMet,
      _ref$state$imageStyle = _ref$state.imageStyle,
      imageStyle = _ref$state$imageStyle === void 0 ? '' : _ref$state$imageStyle;
  var alignmentOptions = [{
    label: 'Full Width',
    value: 'fill'
  }, {
    label: 'Left',
    value: 'flex-start'
  }, {
    label: 'Center',
    value: 'center'
  }, {
    label: 'Right',
    value: 'flex-end'
  }];
  var imageStyleOptions = [{
    label: 'None',
    value: ''
  }, {
    label: 'Round',
    value: 'round'
  }, {
    label: 'Greyscale',
    value: 'greyscale'
  }, {
    label: 'Invert',
    value: 'invert'
  }, {
    label: 'Blur',
    value: 'blur'
  }];
  var loadingMethodOptions = [{
    label: 'Normal',
    value: 'normal'
  }, {
    label: 'Preload',
    value: 'preload'
  }, {
    label: 'Lazyload',
    value: 'lazyload'
  }];
  var imageZoomOptions = [{
    label: 'None',
    value: 'none'
  }, {
    label: 'Lightbox',
    value: 'lightbox'
  }, {
    label: 'Magnify',
    value: 'magnify'
  }];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_File["default"], {
    label: "Image",
    value: url,
    onChange: function onChange(value) {
      return _onChange({
        url: value
      });
    },
    isInline: false
  }), /*#__PURE__*/_react["default"].createElement(_File["default"], {
    label: "Mobile Image",
    value: mobileUrl,
    onChange: function onChange(value) {
      return _onChange({
        mobileUrl: value
      });
    },
    isInline: false
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Image title",
    value: title,
    onChange: function onChange(e) {
      return _onChange({
        title: e.target.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Image alt text",
    value: alt,
    onChange: function onChange(e) {
      return _onChange({
        alt: e.target.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Alignment",
    value: alignment,
    onChange: function onChange(e) {
      return _onChange({
        alignment: e.value
      });
    },
    options: alignmentOptions
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Image Zoom",
    value: imageZoom,
    onChange: function onChange(e) {
      return _onChange({
        imageZoom: e.value
      });
    },
    options: imageZoomOptions
  }), !!imageZoom && imageZoom !== 'none' && /*#__PURE__*/_react["default"].createElement(_File["default"], {
    label: "Zoom Image URL",
    value: largeImageUrl,
    onChange: function onChange(value) {
      return _onChange({
        largeImageUrl: value
      });
    },
    isInline: false
  }), (!!imageZoom === false || imageZoom === 'none') && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Image link",
    value: link,
    onChange: function onChange(e) {
      return _onChange({
        link: e.target.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Open in new tab",
    checked: openInNewTab,
    onChange: function onChange(e) {
      return _onChange({
        openInNewTab: e.target.checked
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Loading method",
    value: loadingMethod,
    onChange: function onChange(e) {
      return _onChange({
        loadingMethod: e.value
      });
    },
    options: loadingMethodOptions,
    tooltip: "Preload should be used sparingly to improve performance, limit use to large above the fold images."
  })), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Image style",
    value: imageStyle,
    onChange: function onChange(e) {
      return _onChange({
        imageStyle: e.value
      });
    },
    options: imageStyleOptions
  }));
};

var _default = ImageForm;
exports["default"] = _default;